import { jsx } from 'react/jsx-runtime';
import { C as Container } from './index-ca2214b3.js';
import { RangePicker as RangePicker$1 } from 'rc-picker';
import zhCN from 'rc-picker/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import { Button } from 'react-bootstrap';
import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';
import { createRef } from 'react';
import dayjs from 'dayjs';
import '@rjsf/core';
import 'classnames';
import 'react-number-format';
import 'rc-picker/assets/index.css';
import 'styled-components';
import 'path';
import 'react-fast-compare';

function RangePicker(props) {
  const ref = createRef();
  return jsx(Container, {
    ref: ref,
    children: jsx(RangePicker$1, {
      ...props,
      locale: zhCN,
      suffixIcon: jsx("i", {
        className: 'bi bi-calendar3'
      }),
      separator: jsx("i", {
        className: 'bi bi-arrow-right'
      }),
      components: {
        button: function (props) {
          return jsx(Button, {
            ...props,
            size: 'sm',
            type: 'button'
          });
        }
      },
      getPopupContainer: () => ref.current,
      allowClear: {
        clearIcon: jsx("button", {
          className: 'btn-close'
        })
      },
      generateConfig: dayjsGenerateConfig
    })
  });
}

const defaultPresets = [{
  label: '最近7天',
  value: [dayjs().add(-7, 'd'), dayjs()]
}, {
  label: '最近30天',
  value: [dayjs().add(-30, 'd'), dayjs()]
}, {
  label: '最近90天',
  value: [dayjs().add(-90, 'd'), dayjs()]
}, {
  label: '最近1年',
  value: [dayjs().add(-1, 'y'), dayjs()]
}];
function DateRangeWidget(props) {
  const {
    value,
    onChange,
    placeholder,
    options
  } = props;
  const {
    format = 'YYYY-MM-DD',
    presets,
    disabledDate,
    disabledTime
  } = options;
  return jsx(RangePicker, {
    disabledDate: disabledDate,
    disabledTime: disabledTime,
    presets: presets === true ? defaultPresets : presets,
    placeholder: [placeholder, placeholder],
    value: value ? [dayjs(value[0], format), dayjs(value[1], format)] : null,
    onChange: value => {
      if (value) {
        onChange([dayjs(value[0]).format(format), dayjs(value[1]).format(format)]);
      } else {
        onChange(null);
      }
    }
  });
}

export { DateRangeWidget as default };
